import { styled, Paper as MuiPaper, Popper as MuiPopper } from "@mui/material";
import { matisse, linkWater } from "../../../../../../assets/styles/colors";

const PREFIX = "ActionPlanItemPopperStyle";
export const classes = {
  popper: `${PREFIX}-popper`,
  detailsPanel: `${PREFIX}-detailsPanel`,
  typographyDetailsValue: `${PREFIX}-typographyDetailsValue`,
  typographyCaption: `${PREFIX}-typographyCaption`
};

export const Popper = styled(MuiPopper)(({ theme }) => ({
  [`&.${classes.popper}`]: {
    width: theme.typography.pxToRem(600)
  }
}));

export const Paper = styled(MuiPaper)(({ theme }) => ({
  [`&.${classes.detailsPanel}`]: {
    padding: theme.typography.pxToRem(10)
  },
  [`& .${classes.typographyDetailsValue}`]: {
    color: matisse,
    fontSize: theme.typography.pxToRem(16),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  [`& .${classes.typographyCaption}`]: {
    color: linkWater,
    fontSize: theme.typography.pxToRem(14)
  }
}));
